import { fetchStrapiSingleType } from './strapiClient';

export async function fetchNosActionsFromStrapi() {
  return fetchStrapiSingleType('nos-actions');
}
